export enum StatusName {
  PENDING = "pending",
  SUCCESS = "success",
  PROCESSING = "processing",
}

export type StatusType = `${StatusName}`;
